import {
  Dialog,
  useFoundationColorTokens,
  useSpacing,
  useTypography,
} from "@surya-digital/leo-reactjs-material-ui";
import React from "react";
import { useTranslation } from "react-i18next";
import { ErrorSuccessDialogContent } from "../../modules/projects/components/ErrorSuccessDialogContent";

interface SuccessDialogProps {
  title: string;
  message: React.ReactElement | string;
  onClickClose?: VoidFunction;
}

export const SuccessDialog: React.FC<SuccessDialogProps> = ({
  title,
  message,
  onClickClose,
}) => {
  const { t } = useTranslation();
  const spacing = useSpacing();
  const tokens = useFoundationColorTokens();
  const typography = useTypography();

  return (
    <Dialog
      open
      title={title}
      secondaryButtonText={onClickClose ? t("common.close") : undefined}
      onSecondaryButtonClick={onClickClose}
    >
      <ErrorSuccessDialogContent
        spacing={spacing}
        tokens={tokens}
        typography={typography}
        isError={false}
        errorSuccessText={message}
      />
    </Dialog>
  );
};
